module.exports = __webpack_public_path__ + "static/img/下载中心-中央空调系统.01ae180.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/download1/下载中心-中央空调系统.png
// module id = ZvEO
// module chunks = 1